import { useEffect } from 'react'

import type { Column } from '@app/components/base/Table/types'
import type { CompetitorsPricesDataSource } from '../types'

export const useMonitoringIdColumn = (columns: Array<Column<CompetitorsPricesDataSource>>, taskId: number): void => {
  useEffect(() => {
    const monitoringIdColumn = columns.find(column => column.key === 'monitoringId')

    if (monitoringIdColumn) {
      monitoringIdColumn.render = () => `${taskId}`
    }
  }, [])
}
